import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useEffect, useState } from "react";
import { Button, Pagination, SearchInput, Switch } from "ui";

import {
  StaffManagersTable,
  StaffManagerModal,
  ChangeStaffManagerDeleteStatusModal
} from "../../components";
import { useStaffManagersList } from "../../hooks";
import { StaffManagerListItem } from "../../staff.types";

import styles from "./Staff.module.scss";

const Staff = () => {
  const {
    staffManagersList,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    refetchStaffManagers,
    showDeletedOnly,
    setShowDeletedOnly
  } = useStaffManagersList();

  const [managerForChangeDeleteStatus, setManagerForChangeDeleteStatus] =
    useState<StaffManagerListItem | null>(null);
  const [editableManager, setEditableManager] =
    useState<StaffManagerListItem | null>(null);
  const {
    value: isManagerModalOpen,
    setTrue: onOpenModal,
    setFalse: onCloseModal
  } = useBoolean(false);

  const handleCloseModalClick = () => {
    onCloseModal();
    setEditableManager(null);
  };

  useEffect(() => {
    if (editableManager) {
      onOpenModal();
    } else {
      onCloseModal();
    }
  }, [editableManager, onOpenModal, onCloseModal]);

  return (
    <ContentLayout
      title={t("Staff Management")}
      action={
        <Button onClick={onOpenModal} icon={<PlusInSquareIcon />}>
          {t("New Manager")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <div className={styles.pageContent_tableHeaderControls}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={t("Search...")}
          />

          <Switch
            label={t("Deleted Only")}
            checked={showDeletedOnly}
            onChange={(e) => setShowDeletedOnly(e.target.checked)}
          />
        </div>
        <StaffManagersTable
          managers={staffManagersList ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onChangeManagerDeleteStatus={setManagerForChangeDeleteStatus}
          onEditManager={setEditableManager}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <StaffManagerModal
        editableManager={editableManager}
        isOpen={isManagerModalOpen}
        onClose={handleCloseModalClick}
        refetchManagers={refetchStaffManagers}
      />

      <ChangeStaffManagerDeleteStatusModal
        id={String(managerForChangeDeleteStatus?.id)}
        isOpen={Boolean(managerForChangeDeleteStatus)}
        action={managerForChangeDeleteStatus?.isDeleted ? "Restore" : "Delete"}
        // onSuccess={refetchStaffManagers}
        onClose={() => setManagerForChangeDeleteStatus(null)}
      />
    </ContentLayout>
  );
};

export default Staff;
